/* DropdownWrapper.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./DropdownWrapper.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
var wrapperStyle = null;

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
var wrapperStylesUnbounded = null;
export function ToolbarDropdownWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    className: ax(["_1e0c1txw _4cvr1h6o _18u0idpf _1ul91wug", "_p7r11txw _1xdi1txw _1ylx1txw _1fvdglyw"])
  }, children);
}